import { render } from "./KnowledgeBaseTab.vue?vue&type=template&id=6f4aa06e&scoped=true"
import script from "./KnowledgeBaseTab.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseTab.vue?vue&type=script&lang=js"

import "./KnowledgeBaseTab.vue?vue&type=style&index=0&id=6f4aa06e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4aa06e"]])

export default __exports__